const GET_BULK_ORDER_HEADER = 'GET_BULK_ORDER_HEADER';
const SET_BULK_ORDER_HEADER = 'SET_BULK_ORDER_HEADER'

const GET_BULK_ORDER_FLEET_HEADER = 'GET_BULK_ORDER_FLEET_HEADER';
const SET_BULK_ORDER_FLEET_HEADER = 'SET_BULK_ORDER_FLEET_HEADER'

const GET_BULK_ORDER_VENDOR_DETAILS = 'GET_BULK_ORDER_VENDOR_DETAILS';
const SET_BULK_ORDER_VENDOR_DETAILS = 'SET_BULK_ORDER_VENDOR_DETAILS';

const GET_BULK_ORDER_PURCHASE_ORDER = 'GET_BULK_ORDER_PURCHASE_ORDER';
const SET_BULK_ORDER_PURCHASE_ORDER = 'SET_BULK_ORDER_PURCHASE_ORDER'

const GET_BULK_ORDER_FLEET_PURCHASE_DETAIL = 'GET_BULK_ORDER_FLEET_PURCHASE_DETAIL';
const SET_BULK_ORDER_FLEET_PURCHASE_DETAIL = 'SET_BULK_ORDER_FLEET_PURCHASE_DETAIL'

const GET_BULK_ORDER_DESCRIPTION_DROPDOWN = 'GET_BULK_ORDER_DESCRIPTION_DROPDOWN';
const SET_BULK_ORDER_DESCRIPTION_DROPDOWN = 'SET_BULK_ORDER_DESCRIPTION_DROPDOWN'

const SAVE_BULK_ORDER_FLEET_ASSET = 'SAVE_BULK_ORDER_FLEET_ASSET';
const SET_BULK_ORDER_FLEET_ASSET = 'SET_BULK_ORDER_FLEET_ASSET'

const GET_BULK_ORDER_EXCEL_DATA = 'GET_BULK_ORDER_EXCEL_DATA';
const SET_BULK_ORDER_EXCEL_DATA = 'SET_BULK_ORDER_EXCEL_DATA'

const GET_TASK_HEADER_DETAILS = 'GET_TASK_HEADER_DETAILS';
const SET_TASK_HEADER_DETAILS = 'SET_TASK_HEADER_DETAILS'

const GET_TASK_ITEM_DETAILS = 'GET_TASK_ITEM_DETAILS';
const SET_TASK_ITEM_DETAILS = 'SET_TASK_ITEM_DETAILS'

const SAVE_TASK_ASSIGNED_TO = 'SAVE_TASK_ASSIGNED_TO'
const SET_TASK_ASSIGNED_TO = 'SET_TASK_ASSIGNED_TO'

const SAVE_CANCEL_FLEET_ITEM = 'SAVE_CANCEL_FLEET_ITEM'
const SET_CANCEL_FLEET_ITEM = 'SET_CANCEL_FLEET_ITEM'

const SAVE_TASK_COMMENT = 'SAVE_TASK_COMMENT'
const SET_TASK_COMMENT = 'SET_TASK_COMMENT'

const SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL = 'SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL';
const SET_SAVE_BULK_FLEET_PURCHASE_DETAIL = 'SET_SAVE_BULK_FLEET_PURCHASE_DETAIL';

const GET_SAVE_VENDOR_DETAILS = 'GET_SAVE_VENDOR_DETAILS';
const SET_SAVE_VENDOR_DETAILS = 'SET_SAVE_VENDOR_DETAILS';

const SET_BULK_ORDER_ALERT = 'SET_BULK_ORDER_ALERT';

const GET_CREATE_BULK_PO_DETAILS = 'GET_CREATE_BULK_PO_DETAILS';
const SET_CREATE_BULK_PO_DETAILS = 'SET_CREATE_BULK_PO_DETAILS';

const GET_BULK_FLEET_HISTORY_TIMELINE = 'GET_BULK_FLEET_HISTORY_TIMELINE';
const SET_BULK_FLEET_HISTORY_TIMELINE = 'SET_BULK_FLEET_HISTORY_TIMELINE';

const GET_SAVE_BULK_FLEET_PURCHASE_ORDER = 'GET_SAVE_BULK_FLEET_PURCHASE_ORDER';
const SET_SAVE_BULK_FLEET_PURCHASE_ORDER = 'SET_SAVE_BULK_FLEET_PURCHASE_ORDER';

const SAVE_BULK_ORDER_FLEET_BARCODE = 'SAVE_BULK_ORDER_FLEET_BARCODE';
const SET_BULK_ORDER_FLEET_BARCODE = 'SET_BULK_ORDER_FLEET_BARCODE';
const SAVE_CANCEL_BULK_ORDER = 'SAVE_CANCEL_BULK_ORDER';
const SET_CANCEL_BULK_ORDER = 'SET_CANCEL_BULK_ORDER';

export {
    GET_BULK_ORDER_HEADER,
    SET_BULK_ORDER_HEADER,
    GET_BULK_ORDER_FLEET_HEADER,
    SET_BULK_ORDER_FLEET_HEADER,
    GET_BULK_ORDER_VENDOR_DETAILS,
    SET_BULK_ORDER_VENDOR_DETAILS,
    GET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    SET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    GET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    SET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    SAVE_BULK_ORDER_FLEET_ASSET,
    SET_BULK_ORDER_FLEET_ASSET,
    GET_BULK_ORDER_EXCEL_DATA,
    SET_BULK_ORDER_EXCEL_DATA,
    GET_TASK_HEADER_DETAILS,
    SET_TASK_HEADER_DETAILS,
    GET_TASK_ITEM_DETAILS,
    SET_TASK_ITEM_DETAILS,
    SAVE_TASK_ASSIGNED_TO,
    SET_TASK_ASSIGNED_TO,
    SAVE_TASK_COMMENT,
    SET_TASK_COMMENT,
    SAVE_CANCEL_FLEET_ITEM,
    SET_CANCEL_FLEET_ITEM,
    SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    GET_SAVE_VENDOR_DETAILS,
    SET_SAVE_VENDOR_DETAILS,
    GET_BULK_ORDER_PURCHASE_ORDER,
    SET_BULK_ORDER_PURCHASE_ORDER,
    SET_BULK_ORDER_ALERT,
    GET_CREATE_BULK_PO_DETAILS,
    SET_CREATE_BULK_PO_DETAILS,
    GET_BULK_FLEET_HISTORY_TIMELINE,
    SET_BULK_FLEET_HISTORY_TIMELINE,
    SET_SAVE_BULK_FLEET_PURCHASE_DETAIL,
    GET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    SET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    SAVE_BULK_ORDER_FLEET_BARCODE,
    SET_BULK_ORDER_FLEET_BARCODE,
    SAVE_CANCEL_BULK_ORDER,
    SET_CANCEL_BULK_ORDER
};